import Grid from 'components/Grid';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SelectableGridRowWrapper: FunctionComponent<Props> = ({
    children,
    className = '',
    ref,
    style,
    testId = TEST_ID
}) => (
    <Grid
        className={`${className} ${styles.selectableGridRowWrapper}`}
        ref={ref}
        style={style}
        testId={testId}>
        {children}
    </Grid>
);

export default SelectableGridRowWrapper;
